// common/RDVButton.js
import React from "react";
import styled from "styled-components";
import { settings } from "../data/settings";
import theme from "../theme";
import { IoMailOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

// Style du bouton RDV
const Button = styled.button`
  padding: 0.6rem 1.1rem;
  background-color: var(--my-color5);
  color: white;
  text-decoration: none;
  border-radius: 8px;
  transition: background-color 0.3s ease;

  font-weight: 400;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  white-space: nowrap;
  height: fit-content;
  width: fit-content;
  text-transform: uppercase;
  display: block;
  margin: auto;
  box-shadow: 0px 0px 6px 0 rgb(0 0 0 / 25%);

  &:hover {
    background-color: var(--my-color4);
  }
`;

const IconButton = styled.button`
  background-color: var(--my-color5);
  color: white;
  text-decoration: none;
  border-radius: 50%;
  transition: background-color 0.3s ease;
  font-weight: 400;
  border: none;
  cursor: pointer;
  font-size: 1.1rem;
  text-transform: uppercase;
  display: block;
  aspect-ratio: 1;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 6px 0 rgb(0 0 0 / 25%);
  &:hover {
    background-color: var(--my-color4);
  }
`;

// Composant RDVButton
export const RDVButton = ({
  label = "Prendre RDV",
  style = {},
  invertColor = false,
  onlyIcon = false,
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    const link = settings?.rdvLink;
    if (link && link.startsWith("https://calendly.com")) {
      if (window.Calendly) {
        window.Calendly.initPopupWidget({ url: link });
      } else {
        window.open(link, "_blank");
      }
    } else {
      navigate(link);
    }
  };

  if (onlyIcon) {
    return (
      <IconButton style={style} onClick={handleClick}>
        <IoMailOutline />
      </IconButton>
    );
  } else {
    return (
      <Button style={style} onClick={handleClick}>
        {label}
      </Button>
    );
  }
};

const TitleSectionTheme = styled.div`
  text-align: left;
  margin: 2rem;
  font-size: var(--title-size);
  color: var(--my-color3);
  font-weight: 600;
  text-transform: uppercase;
  position: relative;
  isolation: isolate; /* create new stacking context */
  z-index: 1;
  font-family: sans-serif;
  line-height: var(--title-size);

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 40%;
    background: var(--my-color5);
    opacity: 0.6;
    z-index: -1;
  }

  ${theme.breakpoints.down("sm")} {
    margin: 1rem;
    margin-bottom: 1rem;
    font-size: calc(var(--title-size) - 1rem);
    line-height: calc(var(--title-size) - 1rem);
    text-transform: uppercase;

    &::after {
      width: 100%;
      height: 45%;
    }
  }
`;

export const TitleSection = ({ children, style }) => {
  return <TitleSectionTheme style={style}>{children}</TitleSectionTheme>;
};

// Subtitle for secondary lines
export const SubtitleSection = styled.p`
  font-size: 1.25rem;
  margin: 0.5rem 0 0;
  text-align: center;
  color: var(--my-color3);
  font-weight: 300;

  ${theme.breakpoints.down("sm")} {
    font-size: 1.1rem;
  }
`;

// Responsive inner container – max width + mobile side padding
export const Inner = styled.div`
  width: 100%;
  margin: auto;
  max-width: 1000px;
  padding: 0;

  ${theme.breakpoints.down("sm")} {
    padding: 0rem 1rem;
    width: auto;
  }
`;
